import { useEffect } from "react"

import { mediaApi } from "@/lib/storage/api/media-api"
import { tripsApi } from "@/lib/storage/api/trips-api"
import { useAppDispatch } from "@/lib/storage/hooks"
import { TripSync, TripSyncMessage } from "@/lib/trip-sync"

// sync trip data across browser tabs
export function useTripSync() {
  const dispatch = useAppDispatch()

  useEffect(() => {
    const handleSyncMessage = (message: TripSyncMessage) => {
      switch (message.type) {
        case "PLACE_ADDED_TO_TRIP":
        case "PLACE_REMOVED_FROM_TRIP":
          if (message.placeRef) {
            dispatch(
              tripsApi.util.invalidateTags([
                { type: "PlaceTripRefs", id: message.placeRef },
              ])
            )
          }
          break
        case "TRIP_CREATED":
        case "TRIP_DELETED":
          dispatch(tripsApi.util.invalidateTags(["Trips", "NavTrips"]))
          break
        case "TRIP_REFS_INVALIDATED":
          if (message.placeRefs) {
            dispatch(
              tripsApi.util.invalidateTags(
                message.placeRefs.map((placeRef) => ({
                  type: "PlaceTripRefs",
                  id: placeRef,
                }))
              )
            )
          } else {
            dispatch(tripsApi.util.invalidateTags(["PlaceTripRefs"]))
          }
          break
        case "MEDIA_TRIP_REFS_INVALIDATED":
          if (message.mediaRefs) {
            dispatch(
              mediaApi.util.invalidateTags(
                message.mediaRefs.map((mediaRef) => ({
                  type: "MediaTripRefs",
                  id: mediaRef,
                }))
              )
            )
          } else {
            dispatch(mediaApi.util.invalidateTags(["MediaTripRefs"]))
          }
          break
      }
    }

    TripSync.instance.addListener(handleSyncMessage)

    return () => {
      TripSync.instance.removeListener(handleSyncMessage)
    }
  }, [dispatch])
}
